<div class="w-full p-8 bg-zinc-100 mon-portfolio flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div class="w-full p00 flex-col justify-start items-start gap-2.5 inline-flex">
        <div class="self-stretch h-full flex-col justify-start items-start gap-5 flex">
          <!-- Titre et gestion du statut -->
          <div class="self-stretch flex-col justify-start items-center gap-6 flex">
            <div class="self-stretch flex-col justify-start items-start gap-6 flex">
              <div class="self-stretch flex-col justify-start items-start gap-5 flex">
                <div class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex">
                  <div class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                    <div class="text-2xl font-semibold mb-4">
                      DOSSIER DE {{ candidatName.toUpperCase() }} eeeee
                    </div>
                    <div>
                      Cohorte: {{ cohorte }} / Statut actuel:
                      {{ currentStatus }}
                    </div>
                  </div>

                  <!-- Section de gestion du statut -->
                  <div class="justify-start items-center gap-3 flex">
                    <select [(ngModel)]="selectedStatus" (ngModelChange)="onStatusSelectionChange($event)" style="
                        padding: 8px;
                        border-radius: 4px;
                        border: 1px solid #ccc;
                        min-width: 200px;
                      ">
                      <option *ngFor="let status of statusOptions" [value]="status.value">
                        {{ status.label }}
                      </option>
                    </select>

                    <button (click)="saveStatusChange()" [disabled]="!isStatusChanged"
                      [style.opacity]="isStatusChanged ? '1' : '0.5'" [style.cursor]="
                        isStatusChanged ? 'pointer' : 'not-allowed'
                      "
                      class="px-4 py-2.5 rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex"
                      style="background-color: #00a13a; color: white">
                      <div class="text-white font-semibold leading-tight">
                        Enregistrer
                      </div>
                    </button>

                    <button (click)="goBack()"
                      class="px-4 py-2.5 rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex"
                      style="
                        background-color: #6c757d;
                        color: white;
                        cursor: pointer;
                      ">
                      <div class="text-white font-semibold leading-tight">
                        Retour
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="self-stretch h-full flex-col justify-start items-center gap-4 flex">
            <div class="self-stretch h-full flex-col justify-start items-start gap-8 flex">
              <div class="self-stretch h-full flex-col justify-start items-start gap-4 flex">
                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

                  <div *ngFor="let document of documentsList"
                    class="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 overflow-hidden">
                    <div class="p-5 flex items-center justify-between">

                      <div class="flex items-center gap-3">

                        <div class="w-14 h-14 rounded-xl flex items-center justify-center"
                          [ngClass]="getFileType(document.childFolderName).bg">

                          <!-- PDF -->
                          <svg *ngIf="getFileType(document.childFolderName).icon === 'pdf'"
                            xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-red-600" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                              d="M7 3h7l5 5v13H7z" />
                          </svg>

                          <!-- EXCEL -->
                          <svg *ngIf="getFileType(document.childFolderName).icon === 'excel'"
                            xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-green-600" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <rect x="4" y="3" width="16" height="18" rx="2" stroke-width="2" />
                            <path d="M9 9L15 15M15 9L9 15" stroke-width="2" />
                          </svg>

                          <!-- WORD -->
                          <svg *ngIf="getFileType(document.childFolderName).icon === 'word'"
                            xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-blue-600" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <rect x="4" y="3" width="16" height="18" rx="2" stroke-width="2" />
                            <path d="M7 8L9 16L12 10L15 16L17 8" stroke-width="2" />
                          </svg>

                          <!-- IMAGE -->
                          <svg *ngIf="getFileType(document.childFolderName).icon === 'image'"
                            xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-purple-600" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                              d="M4 16l4-4 4 4 6-6 2 2v6H4z" />
                          </svg>

                          <!-- DEFAULT -->
                          <svg *ngIf="getFileType(document.childFolderName).icon === 'file'"
                            xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-slate-500" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                              d="M7 3h8l5 5v13H7z" />
                          </svg>

                        </div>

                        <div>
                          <h4 class="font-semibold text-slate-800">
                            {{ getFileType(document.childFolderName).label }}
                          </h4>

                          <p class="text-xs text-slate-500">
                            {{ document.createdAt | date:'dd/MM/yyyy' }}
                          </p>
                        </div>

                      </div>

                    </div>
                    <div class="border-y border-slate-100 bg-slate-50 px-5 py-4">
                      <h3 class="font-semibold text-slate-800 break-words">
                        {{ document.childFolderName }}
                      </h3>
                      <div class="mt-4 flex justify-between">
                        <span class="px-3 py-1 rounded-full text-xs" [ngClass]="[
                            getFileType(document.childFolderName).bg,
                            getFileType(document.childFolderName).text
                          ]">
                          {{ getFileType(document.childFolderName).label }}
                        </span>
                        <span class="text-sm text-slate-500">
                          {{ document.size }} KB
                        </span>
                      </div>
                    </div>
                    <div class="p-4 flex gap-3">
                      <button (click)="openDoc(document)"
                        class="flex-1 h-11 rounded-xl bg-orange text-white font-medium hover:opacity-90 transition">
                        Afficher
                      </button>
                    </div>
                    <!-- <div class="p-4 flex justify-end">
                      <button (click)="openDoc(document)"
                        class="h-11 px-6 rounded-xl bg-orange text-white font-medium hover:opacity-90 transition">
                        Afficher
                      </button>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>